/** 仅在明确请求的产品全部被后端拒绝时判定全无权限，不能用空数据推断。 */
export const getIncomePermissionState = (requestedIds: readonly string[] = [], deniedIds: readonly string[] = []) => {
  const noPermissionDbtIds = [...new Set(deniedIds)]
  const denied = new Set(noPermissionDbtIds)
  return {
    noPermissionDbtIds,
    allDenied: requestedIds.length > 0 && requestedIds.every((id) => denied.has(id)),
  }
}

/** 展示后端拒绝的产品 ID，避免产品名称缓存缺失或重名造成误导。 */
export const getIncomePermissionMessage = (deniedIds: readonly string[]) =>
  deniedIds.length ? `以下产品没有内购收入权限：${deniedIds.join('、')}` : ''
